export default 'M12 0a8 8 0 0 1 6.92 12L12 24 5.08 12a7.95 7.95 0 0 1 1.26-9.66A8 8 0 0 1 12 0m0 10.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5';